/*
  MS-243: Account chooser behavior.
  Markup: snippets/account-chooser.liquid
  Any element with data-account-chooser-open opens the chooser instead of
  following its link. If this file fails to load, the link still works as before.
*/
if (!customElements.get('account-chooser')) {
  class AccountChooser extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('dialog');
      if (!this.dialog || typeof this.dialog.showModal !== 'function') return;

      this.onDocumentClick = this.onDocumentClick.bind(this);
      document.addEventListener('click', this.onDocumentClick);
      this.dialog.addEventListener('click', this.onDialogClick.bind(this));

      // Esc: run our animated close instead of the browser's instant one
      this.dialog.addEventListener('cancel', (event) => {
        event.preventDefault();
        this.close();
      });
    }

    disconnectedCallback() {
      document.removeEventListener('click', this.onDocumentClick);
    }

    onDocumentClick(event) {
      const opener = event.target.closest('[data-account-chooser-open]');
      if (!opener) return;
      // Let Cmd/Ctrl/Shift + click open the link in a new tab as usual
      if (event.metaKey || event.ctrlKey || event.shiftKey) return;

      event.preventDefault();
      if (!this.dialog.open) this.dialog.showModal();
    }

    onDialogClick(event) {
      if (event.target.closest('[data-account-chooser-close]')) {
        this.close();
        return;
      }

      // A click on the dimmed backdrop lands on the <dialog> itself, outside its box
      if (event.target === this.dialog) {
        const box = this.dialog.getBoundingClientRect();
        const outside = event.clientX < box.left || event.clientX > box.right ||
          event.clientY < box.top || event.clientY > box.bottom;
        if (outside) this.close();
      }
    }

    // Plays the closing animation from account-chooser.css, then closes the dialog
    close() {
      const dialog = this.dialog;
      if (!dialog.open || dialog.classList.contains('is-closing')) return;

      let finished = false;
      const finish = () => {
        if (finished) return;
        finished = true;
        dialog.classList.remove('is-closing');
        dialog.close();
      };

      dialog.classList.add('is-closing');

      // Reduced motion turns the animation off, so there is nothing to wait for
      if (getComputedStyle(dialog).animationName === 'none') {
        finish();
        return;
      }
      dialog.addEventListener('animationend', finish, { once: true });
      setTimeout(finish, 500); // Safety net in case animationend never fires
    }
  }
  customElements.define('account-chooser', AccountChooser);
}
